import button from './components/button';
import headerImage from './components/headerImage';
import leaderboardRewards from './components/leaderboardRewards';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'New Rewards Added',
  value: 'new-rewards',
  usersContext: 'LEADERBOARDS',
  subject: 'New rewards added to the platform!',
  mjml(params) {
    const { brandingSettings: branding, leaderboard } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    const { prizes } = leaderboard;

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          padding="44px 16px 0px 16px">${leaderboardRewards(prizes)}</mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          ${slots[1] && slots[1].content ? `<mj-column>${button(slots[1].content, branding)}</mj-column>` : ''}
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <h1>New rewards added to the platform!</h1>
        <p>We've added some awesome new rewards to the platform.</p>
        <p>Just login to take a look at what you could win.</p>
        <p>As a reminder, some of the rewards currently available are below.</p>
      `,
    },
    {
      name: 'Button Text',
      type: 'input',
      defaultContent: 'Login to win!',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/new-rewards.js